import React from 'react';

/**
 * Check if a ReactNode was created by a Component.
 * Also assert the `node` type to be `React.ReactElement` with props type inferred.
 *
 * @example
 *      isComponentType(Component1, <Component1 />) // => true
 *      isComponentType(Component1, <Component2 />) // => false
 */
export const isComponentType = <T extends React.ElementType>(
    type: T,
    node: React.ReactNode,
): node is T extends React.ElementType<infer P> ? React.ReactElement<P> : React.ReactElement => {
    return React.isValidElement(node) && node.type === type;
};
